import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import cx from 'classnames';
import Button from 'react-bootstrap/lib/Button';
import FormGroup from 'react-bootstrap/lib/FormGroup';

import InputFieldComponent from '../../../Common/FormField/InputFieldComponent';

import messages from '../../../../locale/messages';
import validate from './validate';
import { createSmtpData } from '../../../../actions/siteadmin/SmtpSetup/manageSmtpData';
import { smtpSetupForm } from '../../../../helpers/SmtpSetup/smtpSetupForm'
import { encode } from '../../../../helpers/queryEncryption';
import getSMTPToolTipType from '../../../../helpers/getSMTPToolTipType';

import s from './SMTPForm.css';
import bt from '../../../../components/commonStyle.css';

class SMTPForm extends Component {

  constructor(props) {
    super(props);
  }

  handleFormSubmit = async (values) => {
    const { createSmtpData, paginationData, currentPage } = this.props;
    await createSmtpData({
      id: values?.id,
      smtpName: values?.smtpName,
      smtpHost: encode(values?.smtpHost),
      smtpPort: encode(values?.smtpPort),
      smtpEmail: encode(values?.smtpEmail),
      smtpSender: encode(values?.smtpSender),
      smtpSenderEmail: encode(values?.smtpSenderEmail),
      smtpPassword: encode(values?.smtpPassword),
      currentPage
    });
    !values?.id && paginationData(1);
  }

  render() {
    const { error, handleSubmit, submitting, id } = this.props;
    const { formatMessage } = this.props.intl;
    const formFields = smtpSetupForm();

    return (
      <div className={cx(s.formMaxWidth, 'maxwidthcenter', 'empty')}>
        <form onSubmit={handleSubmit(this.handleFormSubmit)}>
          {error && <strong>{formatMessage(error)}</strong>}
          {
            formFields && formFields?.map((item) => {
              return (
                <FormGroup className={s.space3}>
                  <Field
                    name={item}
                    type="text"
                    component={InputFieldComponent}
                    inputClass={cx(bt.commonControlInput)}
                    label={formatMessage(messages[item])}
                    placeholder={formatMessage(messages[item])}
                    infoText={getSMTPToolTipType(item)}
                    showToolTip={true}
                  />
                </FormGroup>
              )
            })
          }
          <FormGroup className={s.formGroup}>
            <div className={cx(bt.textAlignRight, 'textAlignLeftRtl')}>
              <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                {id ? <FormattedMessage {...messages.update} /> : <FormattedMessage {...messages.addLabel} />}
              </Button>
            </div>
          </FormGroup>
        </form>
      </div>
    )
  }
}

SMTPForm = reduxForm({
  form: "SMTPForm", // a unique name for this form
  validate,
})(SMTPForm);

const selector = formValueSelector('SMTPForm');

const mapState = (state) => ({
  id: selector(state, 'id')
});

const mapDispatch = {
  createSmtpData
};

export default injectIntl(withStyles(s, bt)(connect(mapState, mapDispatch)(SMTPForm)));